<template>
<div>
  <b-card>
    <b-row class="mb-3">
      <b-col sm="6" lg="6" xl="4" class="col-xxl-3" >
        <b-form-select v-on:change="changeYear" :options="yearSelectedOptions" name="yearSelected" v-model="year" placeholder="Ano"  v-validate="'required'" ></b-form-select>
      </b-col>
    </b-row>
    <grid-filters grid-data="dsrPointsSpentGrid" :fields="gridFilters" ></grid-filters>
    <div class="text-right mb-3">
      <b-button variant="success" class="text-white" :disabled="exporting" v-on:click="exportGrid()"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar</b-button>      
    </div>
    <Grid v-if="gridReady" ref="dsrPointsSpentGrid" name="dsrPointsSpentGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      exporting: false,
      fileDownload: {
        url: '',
        title: ''
      },
      yearSelectedOptions: [],
      year: 0,
      gridReady: false,
      gridFilters: [{
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      url: 'dsr/points_spent',
      baseurl: 'dsr/points_spent',
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      columns: [{
        field: 'dsr_id',
        title: 'DSR Id',
        width: '80px'
      }, {
        field: 'first_name',
        title: 'Nome próprio',
        width: '120px'
      },
      {
        field: 'last_name',
        title: 'Apelido',
        width: '120px'
      },
      {
        field: 'username',
        title: 'Utilizador',
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '120px',
        values: []
      }, {
        field: 'past_points',
        title: 'Pontos anteriores',
        width: '120px'
      }, {
        field: 'g1',
        title: 'Jan',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g2',
        title: 'Fev',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g3',
        title: 'Mar',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g4',
        title: 'Abr',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g5',
        title: 'Mai',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g6',
        title: 'Jun',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g7',
        title: 'Jul',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g8',
        title: 'Ago',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g9',
        title: 'Set',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g10',
        title: 'Out',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g11',
        title: 'Nov',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }, {
        field: 'g12',
        title: 'Dez',
        width: '120px',
        format: '{0:n0}',
        sortable: false,
        filterable: false
      }]
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.dsrPointsSpentGrid.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post(this.baseurl + '/export/' + this.year, {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
    changeYear: function () {
      this.gridReady = false
      var that = this
      this.url = this.baseurl + '/' + this.year
      setTimeout(() => {
        that.gridReady = true        
      }, 500);
    },
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'dsr_points.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('dsr_points.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  },
  created() {
    let y = (new Date()).getFullYear()
    this.year = y
    this.url = this.baseurl + '/' + this.year
    this.gridReady = true
    for(let i=2012; i<=y; i++) {
      this.yearSelectedOptions.push(i)
    }
  }
}
</script>
